const SCENARIO_METADATA_BY_FAMILY = {
  solo_license: {
    'Privates Video / Erinnerungsfilm': { title: 'Privates Video / Urlaubsvideo' },
    'Schulprojekt': {},
    'Universitätsprojekt': { title: 'Universitätsprojekt / Hausaufgabe' },
    'Private Meditation / Audio-Projekt': { title: 'Meditation (privat, ohne Online-Veröffentlichung)' },
    'Podcast / Webinar (einzelne Ausgabe)': {},
    'YouTube Video / Social Video (einmalig)': { title: 'YouTube Video / Social Video' },
    'Social Shorts / Reels / TikTok': { match_all: ['channel_scope_single_channel', 'content_model_standard'] },
    'Online-Kurs oder Webinar (einzelne Ausgabe)': { match_any: ['content_model_paid_product', 'marketing_intent_promotional'] },
    'Livestream': { match_any: ['channel_scope_single_channel', 'channel_scope_multi_channel'], match_all: ['content_model_standard'] },
    'Erklärvideo (einzelnes Projekt)': { title: 'Erklärvideo', match_any: ['usage_relation_own_use', 'usage_relation_client_channels'], match_all: ['content_model_standard'] },
    'Kurzfilm': { match_all: ['usage_relation_own_use', 'content_model_standard'] },
    'Homepage-Hintergrundvideo': { match_all: ['usage_relation_own_use', 'channel_scope_single_channel', 'content_model_standard'], exclude_any: ['usage_relation_client_channels'] },
    'Präsentation / Slideshow / Dia-Show': {},
    'Hörbuch / Hörspiel (einzelnes Projekt / einzelne Folge)': { match_all: ['content_model_standard'] },
    'Podcast (mehrere Folgen) / Podcast-Intro': { match_all: ['usage_intensity_multi_use'] },
    'Verkaufte Meditation / Audio-Programm (wiederkehrend)': { match_all: ['content_model_paid_product', 'usage_intensity_multi_use'] },
    'Produktvideo / E-Commerce Content': { match_all: ['usage_relation_own_use', 'marketing_intent_promotional'] },
    'Kundenkooperation / Sponsored Content': { match_all: ['usage_relation_collab_on_own_channels', 'marketing_intent_promotional'] },
    'Produktpräsentation / Demo für Kundenprodukt': { match_all: ['usage_relation_client_channels', 'marketing_intent_promotional'] },
    'YouTube Video / Social Video (mehrere Videos eines Kanals oder Accounts)': { title: 'YouTube Video / Social Video (mehrere Videos eines Kanals oder Accounts)', match_all: ['usage_intensity_multi_use'] },
    'Event-Aftermovie / Messefilm': { match_any: ['usage_relation_own_use', 'usage_relation_client_channels'], match_all: ['marketing_intent_promotional'] },
    'Kundenprojekt ohne Broadcast': { match_all: ['usage_relation_client_channels', 'content_model_standard'] },
    'Webinar-Reihe / Webinar-Intro': { match_all: ['usage_intensity_multi_use'] },
    'Intro / Outro / Audio-Logo für Serienformate': { match_all: ['usage_intensity_multi_use'], match_any: ['format_branding_scope_series_intro_outro', 'format_branding_scope_signature_branding'] },
    'Meta Ads / Paid Social': { match_any: ['paid_budget_tier_250', 'paid_budget_tier_2000', 'paid_budget_tier_10000'] },
    'YouTube Ads / Video Promotion': { match_any: ['paid_budget_tier_250', 'paid_budget_tier_2000', 'paid_budget_tier_10000'] },
    'Podcast / Podcast-Folge mit Paid Ads': { match_any: ['paid_budget_tier_250', 'paid_budget_tier_2000', 'paid_budget_tier_10000'] },
    'Meditation / Audio-Programm mit Paid Ads': { match_all: ['content_model_paid_product', 'usage_intensity_multi_use'], match_any: ['paid_budget_tier_250', 'paid_budget_tier_2000', 'paid_budget_tier_10000'] },
    'Verkauftes Hörbuch / Audio-Serie mit Paid Ads': { match_all: ['content_model_paid_product', 'usage_intensity_multi_use'], match_any: ['paid_budget_tier_250', 'paid_budget_tier_2000', 'paid_budget_tier_10000'] }
  },
  business_license: {
    'Interne Kommunikation (kleines Unternehmen)': { match_all: ['paid_budget_tier_organic'] },
    'Imagefilm / Unternehmensvideo': { match_all: ['content_model_standard'] },
    'Tourismus- und Hotel-Marketingvideo': { match_all: ['content_model_standard'] },
    'Recruiting-Video': { match_all: ['content_model_standard'] },
    'App- oder SaaS-Erklärvideo': { match_all: ['content_model_standard'] },
    'Interne Unternehmenskommunikation': { title: 'Interne Kommunikation', match_all: ['paid_budget_tier_organic'] },
    'Konferenzfilm / Messe-Recap / Event-Trailer': { match_all: ['content_model_standard'] },
    'Dokumentation / Reportage / Redaktionelle Online-Videos': { match_all: ['content_model_standard'] },
    'Audioguide / Museum / Tour': { match_any: ['usage_intensity_multi_use', 'usage_intensity_single_use'] },
    'App / Software mit eingebetteter Musik': { match_all: ['content_model_standard'] },
    'Corporate TV / IPTV / redaktionelles Unternehmensformat': { match_all: ['content_model_standard'] },
    'Immobilienmarketing / Makler- oder Bauträger-Video': { match_all: ['content_model_standard'] },
    'Kundenkooperation / Sponsored Content': { match_all: ['usage_relation_collab_on_own_channels'] },
    'Produktpräsentation / Demo für Kundenprodukt': { match_all: ['usage_relation_client_channels'] },
    'LinkedIn Ads / B2B oder Recruiting': { match_any: ['paid_budget_tier_2000', 'paid_budget_tier_10000', 'paid_budget_tier_50000'] },
    'Online Ad / Content Promotion': { match_any: ['paid_budget_tier_2000', 'paid_budget_tier_10000', 'paid_budget_tier_50000'] }
  },
  premium_license: {
    'TV-Spot': {},
    'Radio-Spot': {},
    'Kinospot': {}
  },
  campaign_license: {
    'Markenkampagne / Agenturprojekt': {},
    'Nationale Kampagne / Produktlaunch': { match_all: ['territory_scope_one_country'] },
    'Professionelle Online-Kampagne / Digital Ads': {},
    'Recruiting-Kampagne / Employer Branding': {},
    'Hauptkampagne / Launch in mehreren Märkten': { match_any: ['territory_scope_dach', 'territory_scope_europe', 'territory_scope_global'] },
    'Hero Asset / zentrale Markenkampagne': {},
    'Große Paid-Media-Kampagne / OOH / Retail Media': {},
    'Broadcast-Kampagne mit größerem Rollout': { match_any: ['territory_scope_dach', 'territory_scope_europe', 'territory_scope_global', 'rights_module_film_trailer'] }
  }
};

function buildCoveredScenarios(familyKey, scenarioCatalogByFamily) {
  const familyScenarioMetadata = SCENARIO_METADATA_BY_FAMILY[familyKey] || {};
  const familyScenarioTitles = Array.isArray(scenarioCatalogByFamily?.[familyKey]) ?
    scenarioCatalogByFamily[familyKey].filter((scenarioTitle) => Object.prototype.hasOwnProperty.call(familyScenarioMetadata, scenarioTitle)) :
    Object.keys(familyScenarioMetadata);

  return familyScenarioTitles.map((scenarioTitle) => {
    const scenarioMetadata = familyScenarioMetadata[scenarioTitle] || {};
    const { title, ...rest } = scenarioMetadata;

    return {
      title: title || scenarioTitle,
      ...rest
    };
  });
}

export function buildProjectLicenseConfigFamilies(_locale = 'de', scenarioCatalogByFamily = null) {
  return [
    {
      key: 'solo_license',
      title: 'Solo',
      description: 'Für Einzelpersonen, Creator und kleine Projekte.',
      gross_price_cents: 1495,
      covered_scenarios: buildCoveredScenarios('solo_license', scenarioCatalogByFamily),
      covered_scenarios_note: 'Solo bleibt der Raum für Einzelpersonen. Auch professionelle Kunden- und Podcast-/Webinar-Fälle können hier hineinfallen, solange kein Business-, Premium- oder Campaign-Kontext entsteht.',
      questions: [
        {
          key: 'channel_scope',
          title: 'Wo möchten Sie die Musik einsetzen?',
          options: [
            { key: 'channel_scope_single_channel', label: 'Auf einem Kanal', summary: 'Zum Beispiel nur YouTube, nur Instagram oder ein Podcast auf einer einzelnen Streaming-Plattform', price_delta_cents: 0 },
            { key: 'channel_scope_multi_channel', label: 'Auf mehreren Kanälen', summary: 'Zum Beispiel Website, Social Media und weitere eigene Ausspielorte', price_delta_cents: 1000 }
          ]
        },
        {
          key: 'usage_relation',
          title: 'Für wen erstellen Sie den Inhalt?',
          options: [
            { key: 'usage_relation_own_use', label: 'Für meine eigenen Inhalte', summary: 'Die Musik wird für eigene Inhalte auf eigenen Kanälen genutzt', price_delta_cents: 0 },
            { key: 'usage_relation_collab_on_own_channels', label: 'Für eine Kooperation auf meinen eigenen Kanälen', summary: 'Sie veröffentlichen den Inhalt weiterhin auf Ihren eigenen Kanälen, aber im Rahmen einer Kooperation', price_delta_cents: 1000 },
            { key: 'usage_relation_client_channels', label: 'Für einen Kunden auf den Kanälen des Kunden', summary: 'Der Inhalt wird auf den Kanälen oder im Projektkontext des Kunden genutzt', price_delta_cents: 2000 }
          ]
        },
        {
          key: 'marketing_intent',
          title: 'Dient der Inhalt der Vermarktung eines Produkts, Services oder Unternehmens?',
          options: [
            { key: 'marketing_intent_non_promotional', label: 'Nein', summary: 'Der Inhalt hat keinen primären Marketing- oder Verkaufsfokus', price_delta_cents: 0 },
            { key: 'marketing_intent_promotional', label: 'Ja', summary: 'Zum Beispiel Produktvideo, E-Commerce-Inhalt, Messefilm oder verkaufsnahes Webinar', price_delta_cents: 1500 }
          ]
        },
        {
          key: 'monetization',
          title: 'Nutzen Sie das YouTube Partner Program oder andere Monetarisierungsprogramme für Ihren Content?',
          options: [
            { key: 'monetization_no', label: 'Nein', summary: 'Der Content läuft ohne aktive Monetarisierungsprogramme auf Plattformen wie YouTube, TikTok oder Twitch', price_delta_cents: 0 },
            { key: 'monetization_yes', label: 'Ja', summary: 'Zum Beispiel YouTube Partner Program, TikTok Creator Rewards oder ähnliche Monetarisierungsprogramme auf Twitch und anderen Plattformen', price_delta_cents: 1000 }
          ]
        },
        {
          key: 'paid_budget_tier',
          title: 'Möchten Sie den Inhalt auch mit Werbebudget pushen?',
          options: [
            { key: 'paid_budget_tier_organic', label: 'Nein, nur organisch', summary: 'Keine bezahlte Ausspielung', price_delta_cents: 0 },
            { key: 'paid_budget_tier_250', label: 'Ja, bis 250 € / Monat', summary: 'Kleiner Werberahmen', price_delta_cents: 1000 },
            { key: 'paid_budget_tier_2000', label: 'Ja, bis 2.000 € / Monat', summary: 'Mittlerer Werberahmen', price_delta_cents: 2000 },
            { key: 'paid_budget_tier_10000', label: 'Ja, bis 10.000 € / Monat', summary: 'Größerer Werberahmen', price_delta_cents: 3500 }
          ]
        },
        {
          key: 'content_model',
          title: 'Ist der Inhalt frei zugänglich oder Teil eines bezahlten Angebots?',
          options: [
            { key: 'content_model_standard', label: 'Frei zugänglich', summary: 'Normale Content-Ausspielung ohne bezahlten Produktzugang', price_delta_cents: 0 },
            { key: 'content_model_paid_product', label: 'Teil eines bezahlten Angebots', summary: 'Die Musik ist Teil eines Produkts, Kurses oder Angebots, für das bezahlt wird', price_delta_cents: 1500 }
          ]
        },
        {
          key: 'format_branding_scope',
          title: 'Wird die Musik als wiederkehrendes Intro, Outro oder Branding-Element genutzt?',
          options: [
            { key: 'format_branding_scope_none', label: 'Nein, nur als normale Nutzung im Inhalt', summary: 'Die Musik wird nicht als wiederkehrendes Intro, Outro oder Branding-Element eingesetzt', price_delta_cents: 0 },
            { key: 'format_branding_scope_series_intro_outro', label: 'Ja, als Intro / Outro für genau ein Format', summary: 'Zum Beispiel als Podcast-Intro oder Serien-Opener, der nur dieses eine Format wiederkehrend begleitet', price_delta_cents: 2500 },
            { key: 'format_branding_scope_signature_branding', label: 'Ja, als prägendes Branding / Verpackung', summary: 'Zum Beispiel als Audio-Logo, fester Marken-Opener oder wiederkehrende Verpackung, die das Format oder den Kanal erkennbar prägt', price_delta_cents: 4500 }
          ]
        },
        {
          key: 'usage_intensity',
          title: 'Möchten Sie die Musik nur einmal oder mehrfach nutzen?',
          options: [
            { key: 'usage_intensity_single_use', label: 'Nur einmal', summary: 'Für einen einzelnen klar abgegrenzten Einsatz, inklusive bis zu 3 Varianten oder Sprachversionen', price_delta_cents: 0, price_multiplier: 1.0 },
            { key: 'usage_intensity_multi_use', label: 'Mehrfach', summary: 'Für mehrere Einsätze innerhalb Ihres Solo-Rahmens, über die 3 mitabgedeckten Varianten oder Sprachversionen hinaus', price_delta_cents: 0, price_multiplier: 1.5 }
          ]
        }
      ]
    },
    {
      key: 'business_license',
      title: 'Business',
      description: 'Für Unternehmen, Teams und strukturierte Kundenprojekte ohne Broadcast. Mehrere Kanäle sind hier im Grundmodell bereits mitgedacht.',
      gross_price_cents: 5995,
      covered_scenarios: buildCoveredScenarios('business_license', scenarioCatalogByFamily),
      covered_scenarios_note: 'Business ist der normale Unternehmens- und Team-Standardfall ohne Broadcast-Nutzung.',
      questions: [
        {
          key: 'usage_relation',
          title: 'Für wen entsteht der Inhalt?',
          options: [
            { key: 'usage_relation_own_use', label: 'Für mein Unternehmen', summary: 'Die Musik wird für eigene Inhalte und eigene Unternehmenskanäle genutzt', price_delta_cents: 0 },
            { key: 'usage_relation_collab_on_own_channels', label: 'Für eine Kooperation auf eigenen Unternehmenskanälen', summary: 'Sie veröffentlichen den Inhalt weiterhin auf eigenen Unternehmenskanälen, aber im Rahmen einer Kooperation', price_delta_cents: 2000 },
            { key: 'usage_relation_client_channels', label: 'Für einen Kunden auf den Kanälen des Kunden', summary: 'Der Inhalt wird auf den Kanälen oder im Projektkontext des Kunden genutzt', price_delta_cents: 4000 }
          ]
        },
        {
          key: 'paid_budget_tier',
          title: 'Mit welchem Werbebudget planen Sie?',
          options: [
            { key: 'paid_budget_tier_organic', label: 'Kein Werbebudget', summary: 'Nur organische Ausspielung', price_delta_cents: 0 },
            { key: 'paid_budget_tier_2000', label: 'Bis 2.000 € / Monat', summary: 'Kleiner bis mittlerer Paid-Rahmen', price_delta_cents: 4000 },
            { key: 'paid_budget_tier_10000', label: 'Bis 10.000 € / Monat', summary: 'Größerer Paid-Rahmen', price_delta_cents: 7000 },
            { key: 'paid_budget_tier_50000', label: 'Bis 50.000 € / Monat', summary: 'Große Paid-Ausspielung', price_delta_cents: 14000 }
          ]
        },
        {
          key: 'content_model',
          title: 'Ist der Inhalt frei zugänglich oder Teil eines bezahlten Angebots?',
          options: [
            { key: 'content_model_standard', label: 'Frei zugänglich', summary: 'Normale Content-Ausspielung ohne bezahlten Produktzugang', price_delta_cents: 0 },
            { key: 'content_model_paid_product', label: 'Teil eines bezahlten Angebots', summary: 'Die Musik ist Teil eines Produkts, Kurses oder Angebots, für das bezahlt wird', price_delta_cents: 2000 }
          ]
        },
        {
          key: 'format_branding_scope',
          title: 'Wird die Musik als wiederkehrendes Intro, Outro oder Branding-Element genutzt?',
          options: [
            { key: 'format_branding_scope_none', label: 'Nein, nur als normale Nutzung im Inhalt', summary: 'Die Musik wird nicht als wiederkehrendes Intro, Outro oder Branding-Element eingesetzt', price_delta_cents: 0 },
            { key: 'format_branding_scope_series_intro_outro', label: 'Ja, als Intro / Outro für genau ein Format', summary: 'Zum Beispiel als Podcast-Intro oder Serien-Opener, der genau dieses eine Format wiederkehrend begleitet', price_delta_cents: 4000 },
            { key: 'format_branding_scope_signature_branding', label: 'Ja, als prägendes Branding / Verpackung', summary: 'Zum Beispiel als Audio-Logo, fester Marken-Opener oder wiederkehrende Verpackung, die das Format oder den Kanal erkennbar prägt', price_delta_cents: 8000 }
          ]
        },
        {
          key: 'usage_intensity',
          title: 'Möchten Sie die Musik nur einmal oder mehrfach nutzen?',
          options: [
            { key: 'usage_intensity_single_use', label: 'Nur einmal', summary: 'Für einen einzelnen klar abgegrenzten Einsatz, inklusive bis zu 3 Varianten oder Sprachversionen', price_delta_cents: 0, price_multiplier: 1.0 },
            { key: 'usage_intensity_multi_use', label: 'Mehrfach', summary: 'Für mehrere Einsätze innerhalb Ihres Business-Rahmens, über die 3 mitabgedeckten Varianten oder Sprachversionen hinaus', price_delta_cents: 0, price_multiplier: 1.5 }
          ]
        }
      ]
    },
    {
      key: 'premium_license',
      title: 'Premium',
      description: 'Für einzelne stärkere Rechtefälle mit Musiknutzung in Radio, TV, Kino, VOD oder Trailern.',
      gross_price_cents: 24995,
      price_matrix: {
        territory_scope_local_broadcast: { rights_term_3m: 24995, rights_term_6m: 32995, rights_term_12m: 42995 },
        territory_scope_one_country: { rights_term_3m: 34995, rights_term_6m: 46995, rights_term_12m: 59995 },
        territory_scope_dach: { rights_term_3m: 54995, rights_term_6m: 69995, rights_term_12m: 89995 },
        territory_scope_four_to_five_countries: { rights_term_3m: 79995, rights_term_6m: 99995, rights_term_12m: 129995 },
        territory_scope_six_to_ten_countries: { rights_term_3m: 109000, rights_term_6m: 139000, rights_term_12m: 179000 }
      },
      matrix_groups: ['territory_scope', 'rights_term'],
      covered_scenarios: buildCoveredScenarios('premium_license', scenarioCatalogByFamily),
      covered_scenarios_note: 'Premium bleibt für einzelne Hauptprojekte mit stärkerem Rechtekontext. Größere Kampagnen mit mehreren Assets würden später in Campaign kippen.',
      questions: [
        {
          key: 'territory_scope',
          title: 'Wo soll das Projekt ausgespielt werden?',
          options: [
            { key: 'territory_scope_local_broadcast', label: 'Lokal / regional', summary: 'Zum Beispiel ein lokaler TV-, Radio- oder Kinoeinsatz', price_delta_cents: 0 },
            { key: 'territory_scope_one_country', label: 'In einem Land', summary: 'Ein nationaler Broadcast- oder VOD-Rahmen in einem Land', price_delta_cents: 0 },
            { key: 'territory_scope_dach', label: 'In DACH', summary: 'Deutschland, Österreich und Schweiz im gemeinsamen Rollout', price_delta_cents: 0 },
            { key: 'territory_scope_four_to_five_countries', label: 'In 4 bis 5 Ländern', summary: 'Mehrländer-Rollout in einem kompakten Gebiet', price_delta_cents: 0 },
            { key: 'territory_scope_six_to_ten_countries', label: 'In 6 bis 10 Ländern', summary: 'Breiterer internationaler Rollout', price_delta_cents: 0 }
          ]
        },
        {
          key: 'rights_term',
          title: 'Wie lange ist die Broadcast-Nutzung geplant?',
          options: [
            { key: 'rights_term_3m', label: '3 Monate', summary: 'Die gewählte Periode gilt für die Broadcast-Nutzung, zum Beispiel TV, Radio oder Kino. Wenn VOD-/OTT-Rechte enthalten sind, dürfen während der gültigen Lizenz veröffentlichte Inhalte danach weiter abrufbar bleiben.', price_delta_cents: 0 },
            { key: 'rights_term_6m', label: '6 Monate', summary: 'Die gewählte Periode gilt für die Broadcast-Nutzung, zum Beispiel TV, Radio oder Kino. Wenn VOD-/OTT-Rechte enthalten sind, dürfen während der gültigen Lizenz veröffentlichte Inhalte danach weiter abrufbar bleiben.', price_delta_cents: 0 },
            { key: 'rights_term_12m', label: '12 Monate', summary: 'Die gewählte Periode gilt für die Broadcast-Nutzung, zum Beispiel TV, Radio oder Kino. Wenn VOD-/OTT-Rechte enthalten sind, dürfen während der gültigen Lizenz veröffentlichte Inhalte danach weiter abrufbar bleiben.', price_delta_cents: 0 }
          ]
        },
        {
          key: 'rights_module_vod_ott',
          title: 'Soll die Musik auch in VOD oder OTT genutzt werden?',
          options: [
            { key: 'rights_module_vod_ott_no', label: 'Nein', summary: 'Die Nutzung ist nur für den gewählten Broadcast-Rahmen gedacht, ohne zusätzliche VOD- oder OTT-Auswertung.', price_delta_cents: 0 },
            { key: 'rights_module_vod_ott', label: 'Ja, bitte mit abdecken', summary: 'Zusätzlich zur Broadcast-Nutzung darf die Musik auch für VOD- oder OTT-Auswertung verwendet werden. Während der gültigen Lizenz veröffentlichte Inhalte dürfen danach weiter abrufbar bleiben.', price_delta_cents: 15000 }
          ]
        },
        {
          key: 'rights_module_film_trailer',
          title: 'Soll die Musik auch für Film- oder Trailer-Nutzung freigegeben sein?',
          options: [
            { key: 'rights_module_film_trailer_no', label: 'Nein', summary: 'Die Nutzung bleibt beim gewählten Broadcast- oder VOD-Rahmen, ohne Film- oder Trailer-Rechte.', price_delta_cents: 0 },
            { key: 'rights_module_film_trailer', label: 'Ja, bitte mit abdecken', summary: 'Zusätzlich zur bisherigen Nutzung soll die Musik auch in Filmtrailern oder ähnlichen Trailer-Kontexten eingesetzt werden dürfen.', price_delta_cents: 20000 }
          ]
        }
      ]
    },
    {
      key: 'campaign_license',
      title: 'Campaign',
      description: 'Für größere Kampagnenrahmen mit mehreren Assets, Produktlaunches und breiterer Ausspielung inklusive VOD / OTT.',
      gross_price_cents: 49995,
      price_matrix: {
        territory_scope_one_country: { rights_term_3m: 49995, rights_term_6m: 62995, rights_term_12m: 74995 },
        territory_scope_dach: { rights_term_3m: 89000, rights_term_6m: 109000, rights_term_12m: 129000 },
        territory_scope_europe: { rights_term_3m: 169000, rights_term_6m: 209000, rights_term_12m: 249000 },
        territory_scope_global: { rights_term_3m: 329000, rights_term_6m: 409000, rights_term_12m: 490000 }
      },
      matrix_groups: ['territory_scope', 'rights_term'],
      covered_scenarios: buildCoveredScenarios('campaign_license', scenarioCatalogByFamily),
      covered_scenarios_note: 'Campaign ist der Raum für größere Kampagnenrahmen mit mehreren Assets und breiterer Markt-Ausspielung.',
      questions: [
        {
          key: 'territory_scope',
          title: 'In welchem Markt soll die Kampagne laufen?',
          options: [
            { key: 'territory_scope_one_country', label: 'In einem Land', summary: 'Nationaler Kampagnenrahmen in einem Land', price_delta_cents: 0 },
            { key: 'territory_scope_dach', label: 'In DACH', summary: 'Kampagnenrollout in Deutschland, Österreich und Schweiz', price_delta_cents: 0 },
            { key: 'territory_scope_europe', label: 'In Europa', summary: 'Europäischer Rollout mit mehreren Märkten', price_delta_cents: 0 },
            { key: 'territory_scope_global', label: 'Weltweit', summary: 'Internationaler Kampagnenrahmen über mehrere Märkte hinweg', price_delta_cents: 0 }
          ]
        },
        {
          key: 'rights_term',
          title: 'Wie lange ist die Kampagne geplant?',
          options: [
            { key: 'rights_term_3m', label: '3 Monate', summary: 'Kampagnenzeitraum für einen klar begrenzten Flight oder Launch. Während der Kampagne veröffentlichte VOD-/OTT-Inhalte dürfen danach weiter abrufbar bleiben.', price_delta_cents: 0 },
            { key: 'rights_term_6m', label: '6 Monate', summary: 'Kampagnenzeitraum für längere Flights, Adaptionen oder Folgeausspielungen. Während der Kampagne veröffentlichte VOD-/OTT-Inhalte dürfen danach weiter abrufbar bleiben.', price_delta_cents: 0 },
            { key: 'rights_term_12m', label: '12 Monate', summary: 'Kampagnenzeitraum für nachhaltigere Rollouts oder Markenauftritte. Während der Kampagne veröffentlichte VOD-/OTT-Inhalte dürfen danach weiter abrufbar bleiben.', price_delta_cents: 0 }
          ]
        },
        {
          key: 'rights_module_film_trailer',
          title: 'Soll die Kampagne zusätzlich auch Trailer- oder Film-Nutzung umfassen?',
          options: [
            { key: 'rights_module_film_trailer_no', label: 'Nein', summary: 'Die Kampagne deckt bereits digitale Nutzung, Paid Media und VOD / OTT ab, aber noch keine zusätzlichen Film- oder Trailer-Rechte.', price_delta_cents: 0 },
            { key: 'rights_module_film_trailer', label: 'Ja, bitte mit abdecken', summary: 'Zusätzlich zum Campaign-Rahmen inklusive VOD / OTT soll die Musik auch in Filmtrailern, Teasern oder ähnlichen Trailer-Kontexten eingesetzt werden dürfen.', price_delta_cents: 15000 }
          ]
        }
      ]
    }
  ];
}
